export default ".tool-wrapper {\n  width: 100%;\n  height: 100%;\n  pointer-events: none;\n}\n\napp-tool-inner {\n  pointer-events: auto;\n}";